import { getRTDates } from "app/pages/activation/components/RankWidget/helpers/getRTDates";
import type { KeywordAvgCreationDTO, RankTrackerCampaign } from "app/pages/activation/types/api";
import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { GranularityNames } from "app/UtilitiesAndConstants/Constants/Moment";

export const prepareRequestKeywordAvgData = (
    data: RankTrackerCampaign | null | undefined,
): KeywordAvgCreationDTO | null => {
    if (!data?.firstScrapeTime) {
        return null;
    }

    const { from, to } = getRTDates(data);

    const scrapingConfigurationGuids =
        data.scrapingConfigurations.find(({ device }) => device === DEVICES_TYPES_FOR_API.DESKTOP)?.id ??
        data.scrapingConfigurations[0].id;

    return {
        campaignguid: data.id,
        sites: data.site,
        to,
        from,
        scrapingConfigurationGuids,
        isDaily: true,
        granularity: GranularityNames.WEEKLY,
        invertedSerpFilter: false,
        mainSiteSerpFilter: false,
    };
};
